import {
  getLocationListData,
  _getLSelectItemDataById,
} from '../locations/mockData'
import {
  getProductListData,
  _getPRSelectItemDataById,
} from '../products/mockData'
import { getListDataFunctionFactory } from '../../modules/getListDataFunctionFactory'
import type { TEntityId } from '~/types/models'
import type { ILocationHardwareCompanyOwnedItem } from '@/types/location/models'
import {
  LocationHardwareStatusIds,
  getLocationHardwareStatusById,
} from '~/services/selectLists/locationHardwareStatii'

const locationHardwareCompanyOwnedItemListData =
  undefined as unknown as ILocationHardwareCompanyOwnedItem[]

export const getLocationHardwareCompanyOwnedItemListData =
  getListDataFunctionFactory<ILocationHardwareCompanyOwnedItem[]>({
    listData: locationHardwareCompanyOwnedItemListData,
    storageKey: 'locationhardwarecompanyowneditems',
    getStartingListData: getStartingLocationHardwareCompanyOwnedItemListData,
  })

export async function getLocationHardwareCompanyOwnedItemListDataByLocationId(
  id: TEntityId
): Promise<ILocationHardwareCompanyOwnedItem[]> {
  const list: ILocationHardwareCompanyOwnedItem[] =
    await getLocationHardwareCompanyOwnedItemListData()
  if (!list) {
    throw new Error(
      `getLocationHardwareCompanyOwnedItemListData returned undefined/null`
    )
  }
  const locationHardwareCompanyOwnedItemListData = list.filter(
    (lhcoi) => lhcoi.location.id === id
  )
  if (!locationHardwareCompanyOwnedItemListData) {
    throw new Error(
      `Can't find locationHardwareCompanyOwnedItemListData '${id}'`
    )
  }
  return locationHardwareCompanyOwnedItemListData
}

export async function getStartingLocationHardwareCompanyOwnedItemListData(): Promise<
  ILocationHardwareCompanyOwnedItem[]
> {
  const stListData = await getProductListData()
  const locListData = await getLocationListData()
  return [
    {
      id: 'XXCOH0001',
      hrid: 'COH0001',
      product: _getPRSelectItemDataById('XXPR0008', stListData)!,
      location: _getLSelectItemDataById('XXL0001', locListData),
      locationDetail: 'Room 103, Desk 1',
      make: 'Avaya',
      model: '9611G',
      sn: '38394583',
      status: getLocationHardwareStatusById(LocationHardwareStatusIds.ACTIVE),
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXCOH0002',
      hrid: 'COH0002',
      product: _getPRSelectItemDataById('XXPR0008', stListData)!,
      location: _getLSelectItemDataById('XXL0001', locListData),
      locationDetail: 'Room 103, Desk 2',
      make: 'Avaya',
      model: '9611G',
      sn: '38394584',
      status: getLocationHardwareStatusById(LocationHardwareStatusIds.ACTIVE),
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXCOH0003',
      hrid: 'COH0003',
      product: _getPRSelectItemDataById('XXPR0008', stListData)!,
      location: _getLSelectItemDataById('XXL0001', locListData),
      locationDetail: 'Room 103, Desk 3',
      make: 'Avaya',
      model: '9611G',
      sn: '38394585',
      status: getLocationHardwareStatusById(LocationHardwareStatusIds.ACTIVE),
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXCOH0004',
      hrid: 'COH0004',
      product: _getPRSelectItemDataById('XXPR0008', stListData)!,
      location: _getLSelectItemDataById('XXL0001', locListData),
      locationDetail: 'Room 103, Desk 4',
      make: 'Avaya',
      model: '9611G',
      sn: '38394586',
      status: getLocationHardwareStatusById(LocationHardwareStatusIds.ACTIVE),
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXCOH0005',
      hrid: 'COH0005',
      product: _getPRSelectItemDataById('XXPR0008', stListData)!,
      location: _getLSelectItemDataById('XXL0001', locListData),
      locationDetail: 'Room 103, Desk 5',
      make: 'Avaya',
      model: '9611G',
      sn: '38394587',
      status: getLocationHardwareStatusById(LocationHardwareStatusIds.ACTIVE),
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXCOH0006',
      hrid: 'COH0006',
      product: _getPRSelectItemDataById('XXPR0008', stListData)!,
      location: _getLSelectItemDataById('XXL0001', locListData),
      locationDetail: 'Room 103, Desk 6',
      make: 'Avaya',
      model: '9611G',
      sn: '38394588',
      status: getLocationHardwareStatusById(LocationHardwareStatusIds.ACTIVE),
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXCOH0007',
      hrid: 'COH0007',
      product: _getPRSelectItemDataById('XXPR0008', stListData)!,
      location: _getLSelectItemDataById('XXL0001', locListData),
      locationDetail: 'Room 103, Desk 7',
      make: 'Avaya',
      model: '9611G',
      sn: '38394589',
      status: getLocationHardwareStatusById(LocationHardwareStatusIds.ACTIVE),
      version: '1',
      canBeDeleted: false,
    },
  ]
}
